import { render, staticRenderFns } from "./newPill.vue?vue&type=template&id=149ebf48&scoped=true"
import script from "./newPill.vue?vue&type=script&lang=js"
export * from "./newPill.vue?vue&type=script&lang=js"
import style0 from "./newPill.vue?vue&type=style&index=0&id=149ebf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ebf48",
  null
  
)

export default component.exports